module.exports = __webpack_public_path__ + "img/img_ticket_center_zhifu.03f9f0ff.png";